module.exports = "//d274d294w9cx2v.cloudfront.net/3047b2793c8deaa138501479a697b32531c2d0bb/images/registryDefaultSmall.webp";